import { render, staticRenderFns } from "./CVModalForm.vue?vue&type=template&id=1c65abdc&scoped=true"
import script from "./CVModalForm.vue?vue&type=script&lang=js"
export * from "./CVModalForm.vue?vue&type=script&lang=js"
import style0 from "./CVModalForm.vue?vue&type=style&index=0&id=1c65abdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c65abdc",
  null
  
)

export default component.exports